<template>
    <paper class="net-task">
        <otp-panel
            ref="tablePage"
            :config="config"
            :pageTotal="pageTotal"
            :loading="loading"
            :totalData="totalData"
            :initSearchInfo="initSearchInfo"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="netTaskManageQuery"
            pageID="netTaskManage"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @row-db-click="rowDBclick"
            @photos-btn="photosBtn"
            @btnClick="btnClick"
            @print-btn="printBtn"
            @feedback-btn="feedbackBtn"
            @branchSign-btn="branchSignBtn"
            @finalSign-btn="finalSignBtn"
            @netInbound-btn="netInboundBtn"
            @netOutbound-btn="netOutboundBtn"
            @clientSign-btn="clientSignBtn"
            @clientReject-btn="clientRejectBtn"
            @rejectConfirm-btn="rejectConfirmBtn"
            @createReturn-btn="createReturnBtn"
            @pickup-btn="pickupBtn"
            @pickupConfirm-btn="pickupConfirmBtn"
            @signConfirm-btn="signConfirmBtn"
            @appointment-btn="appointmentBtn"
            @fundRequest-btn="fundRequestBtn"
            @toReject-btn="toRejectBtn"
            @branchReject-btn="branchRejectBtn"
        >
            <div slot="table-module-btn">
                <!-- <report-export #default="{ submit }" reportCode="REPORT_OTP_NET_TASK_CENTRE">
                    <el-tooltip effect="dark" content="导出" placement="bottom" v-has="'10030001'">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                    </el-tooltip>
                </report-export> -->
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="handleSendout" v-has="'10030021'">下发</el-button>
                <el-dropdown placement="top" v-has="'10030002'">
                    <el-button type="primary">
                        分中心派单
                        <i class="el-icon-arrow-up el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="sendOrder(false)">分中心派单</el-dropdown-item>
                        <el-dropdown-item @click.native="sendOrder(true)">分中心改派</el-dropdown-item>
                        <el-dropdown-item @click.native="sendOrder(true,true)" v-has="'10030020'">跨中心改派</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" @click="engineerDispatch" v-has="'10030003'">派工</el-button>
                <el-button type="primary" @click="handleError" v-has="'10030004'">处理异常</el-button>
                <el-button type="primary" @click="handlePrint" v-has="'10030022'">批量打印派工单</el-button>
            </div>
        </otp-panel>

        <branch-sign
            ref="branchSign"
            v-if="branchSignDialog"
            :type="type"
            :rowData="rowData"
            @branchSignUploadResponse="branchSignUploadResponse"
            :onBeforeUpload="beforeUpload"
            @closeDialog="closeDialog"
        ></branch-sign>
        <branch-sign-new
            ref="branchSignNew"
            v-if="branchSignNewDialog"
            :type="type"
            :rowData="rowData"
            @branchSignUploadResponse="branchSignUploadResponse"
            :onBeforeUpload="beforeUpload"
            @closeDialog="closeDialog"
        ></branch-sign-new>
        <!-- 附件查看-photosBtn -->
        <attachment-view
            ref="attachmentView"
            v-if="netAttachmentShow"
            @typeChange="viewTypeChange"
            :rowData="rowData"
            :onBeforeUpload="beforeUpload"
            @closeDialog="closeDialog"
        ></attachment-view>
        <!-- 异常反馈弹窗 -->
        <error-feedback v-if="errorFeedbackDialog" ref="errorFeedback" @closeDialog="closeDialog"></error-feedback>
        <!-- 打印弹窗 -->
        <printer v-if="printerDialog" ref="printer" @closeDialog="closeDialog"></printer>
        <!-- 预约弹窗 -->
        <appointment v-if="appointmentDialog" ref="appointment" @closeDialog="closeDialog"></appointment>
        <appointment-new v-if="appointmentNewDialog" ref="appointmentNew" @closeDialog="closeDialog"></appointment-new>
        <!-- 派工弹窗 -->
        <engineer-dispatch
            v-if="engineerDispatchDialog"
            ref="engineerDispatch"
            @closeDialog="closeDialog"
        ></engineer-dispatch>
        <!-- 派单弹窗 -->
        <send-order v-if="sendOrderDialog" ref="sendOrder" @closeDialog="closeDialog"></send-order>
        <!-- 远程费用申请 -->
        <fund-request-dialog
        ref="fundRequestDialog"
        v-if="fundRequestDialog"
        @closeDialog="closeDialog"
        :onBeforeUpload="beforeUpload"></fund-request-dialog>
        <el-dialog :visible.sync="logVisible" title="操作日志">
            <dialogTable :tableData="logData" :dialogTable="logTable" v-if="logVisible"></dialogTable>
        </el-dialog>
    </paper>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import OtpPanel from '../../../../components/mulitPanel';
import Paper from '@/components/core/paper/Paper';
import BranchSign from '../components/branchSign/BranchSign';
import BranchSignNew from '../components/branchSignNew/BranchSign';
import AttachmentView from '../components/AttachmentView';
import ErrorFeedback from '../components/ErrorFeedback';
import SendOrder from '../components/SendOrder';
import Appointment from '../components/Appointment';
import AppointmentNew from '../components/appointmentNew/AppointDialog';
import FundRequestDialog from '../components/FundRequestDialog';
import DialogTable from '../../../../components/dialog/dialogTable';
import EngineerDispatch from '../components/EngineerDispatch';
import Printer from '../components/Printer';
import config from './config.js';
import api from '../../../../api/netTaskManage2c.js';
import { mapState, mapGetters } from 'vuex';
import formatTime from '@/utils/common.js';
import { maxTwoMonths, maxOneMonths } from '../../../../utils/common';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    name: 'netTaskManage',
    components: {
        OtpPanel,
        Paper,
        BranchSign,
        BranchSignNew,
        EngineerDispatch,
        AttachmentView,
        ErrorFeedback,
        SendOrder,
        FundRequestDialog,
        Appointment,
        AppointmentNew,
        Printer,
        DialogTable
    },
    data() {
        return {
            config,
            logData: [],
            logTable: config.logTable,
            pageTotal: 0,
            loading: false,
            selected: [],
            totalData: [],
            searchParams: {
                pageSize: 50,
                pageNo: 1
            },
            type: '',
            mulUploadType: '',
            titleName: '',
            appointNoteDataObj: {},
            branchSignDialog: false,
            branchSignNewDialog: false,
            appointmentDialog: false,
            appointmentNewDialog: false,
            engineerDispatchDialog: false,
            sendOrderDialog: false,
            errorFeedbackDialog: false,
            printerDialog: false,
            fundRequestDialog: false,
            netAttachmentShow: false,
            logVisible: false,
            isFirstSearch: true,
            rowData: {},
            exportParams: {},
            initSearchInfo: {}
        };
    },
    created() {
        this.getOptionList();
    },
    activated() {
        const route = this.$route.query;
        if (route && route.getData) {
            this.initSearchInfo = {
                pageNo: 1,
                pageSize: this.searchParams.pageSize,
                orderStatus: route.orderStatus || [],
                KanbanStatus: route.KanbanStatus || ''
            };
            this.initSearchInfo.updateTime = route.updateStartTime ? [route.updateStartTime, route.updateEndTime] : [];
            this.initSearchInfo.createTime = route.startTime ? [route.startTime, route.endTime] : [];
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
                delete route.getData;
                delete route.orderStatus;
                delete route.KanbanStatus;
                delete route.updateStartTime;
                delete route.updateEndTime;
                delete route.startTime;
                delete route.endTime;
            });
        }
    },
    methods: {
        // 获取数据字典
        getOptionList() {
            dictWithUrl('INSTALL_TYPE,NET_APPOINT_TIME_SLOT');
        },
        checkTime(start, end) {
            const st = new Date(start).getTime();
            const et = new Date(end).getTime();
            return (et - st) <= 15 * 24 * 60 * 60 * 1000;
        },
        searchChange(data) {
            if (data.createTime && data.createTime.length) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
                if (!this.checkTime(data.beginDate, data.endDate)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.createTime) {
                data.beginDate = '';
                data.endDate = '';
            }
            delete data.createTime;
            if (
                data.appointmentStartTime &&
                data.appointmentStartTime.length
            ) {
                data.appointmentStartBegin = data.appointmentStartTime[0];
                data.appointmentStartEnd = data.appointmentStartTime[1];
                if (!this.checkTime(data.appointmentStartBegin, data.appointmentStartEnd)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.appointmentStartTime) {
                data.appointmentStartBegin = '';
                data.appointmentStartEnd = '';
            }
            delete data.appointmentStartTime;
            if (data.appointmentEndTime && data.appointmentEndTime.length) {
                data.appointmentEndBegin = data.appointmentEndTime[0];
                data.appointmentEndEnd = data.appointmentEndTime[1];
                if (!this.checkTime(data.appointmentEndBegin, data.appointmentEndEnd)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.appointmentEndTime) {
                data.appointmentEndBegin = '';
                data.appointmentEndEnd = '';
            }
            delete data.appointmentEndTime;
            if (data.requiredPickTime && data.requiredPickTime.length) {
                data.requiredPickTimeBegin = data.requiredPickTime[0];
                data.requiredPickTimeEnd = data.requiredPickTime[1];
                if (!this.checkTime(data.requiredPickTimeBegin, data.requiredPickTimeEnd)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.appointmentEndTime) {
                data.requiredPickTimeBegin = '';
                data.requiredPickTimeEnd = '';
            }
            delete data.requiredPickTime;
            if (data.serviceTime && data.serviceTime.length) {
                data.serviceStartTime = data.serviceTime[0];
                data.serviceEndTime = data.serviceTime[1];
                if (!this.checkTime(data.serviceStartTime, data.serviceEndTime)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.serviceTime) {
                data.serviceStartTime = '';
                data.serviceEndTime = '';
            }
            delete data.serviceTime;
            // 订单状态多选转换
            data.orderStatusList = '';
            if (data.orderStatus && data.orderStatus.length) {
                data.orderStatusList = data.orderStatus;
            }
            delete data.orderStatus;
            // 更新时间
            if (data.updateTime && data.updateTime.length) {
                data.updateStartTime = data.updateTime[0];
                data.updateEndTime = data.updateTime[1];
                if (!this.checkTime(data.updateStartTime, data.updateEndTime)) {
                    this.$message.warning('时间跨度不能超过两周！');
                    return;
                }
            } else if (!data.updateTime) {
                data.updateStartTime = '';
                data.updateEndTime = '';
            }
            delete data.updateTime;
            // 看板数据用参数
            if (data.KanbanStatus) {
                data.kanba = true;
            } else {
                delete data.kanba;
            }
            // 订单类型多选转换
            data.orderTypeList = '';
            if (data.orderType && data.orderType.length) {
                data.orderTypeList = data.orderType;
            }
            delete data.orderType;
            data.pageNo = 1;
            data.pageSize = this.searchParams.pageSize;
            this.searchParams = data;
            for (const key in this.searchParams) {
                if (
                    !this.searchParams[key] &&
                    this.searchParams[key] !== false &&
                    this.searchParams[key] !== 0
                ) {
                    delete this.searchParams[key];
                }
            };
            if (!this.searchParams.orderNo && !this.searchParams.fromDispatchNo &&
            !this.searchParams.waybillNo && !this.searchParams.jpOrderNo &&
            !this.searchParams.beginDate && !this.searchParams.updateStartTime) {
                return this.$message.warning(
                    '订单号 及 时间查询条件至少需输入一项！'
                );
            }
            if (!maxTwoMonths(this, data.beginDate, data.endDate)) return;
            this.exportParams = {
                ...this.searchParams,
                tenantCode: this.currentTenant.tenantCode
            };
            // 当看板跳转到当前页面，若无创建时间参数，将默认给期加上2个月用于导出
            if (this.$route.query.getData && !this.exportParams.beginDate) {
                this.exportParams.beginDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD 00:00:00');
                this.exportParams.endDate = dayjs().format('YYYY-MM-DD 23:59:59');
            }
            this.getList();
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!maxOneMonths(this, this.exportParams.beginDate, this.exportParams.endDate)) return;
            submit(this.exportParams);
            this.isFirstSearch = false;
        },
        async getList() {
            this.loading = true;
            await api.getLists(this.searchParams).then((res) => {
                if (res && res.code === '0') {
                    if (
                        res.data.totalPage !== 0 &&
                            this.searchParams.pageNo > res.data.totalPage
                    ) {
                        this.searchParams.pageNo = res.data.totalPage;
                        this.getList();
                        return;
                    }
                    const list = res.data.list || [];
                    list.forEach((item) => {
                        if (item.firstAppointmentStartTime) {
                            item.firstAppointmentTime =
                                item.firstAppointmentStartTime + (item.firstAppointmentEndTime ? ' - ' +
                                item.firstAppointmentEndTime.split(' ')[1] : '');
                        }
                        if (item.installStartTime) {
                            item.installTime =
                                item.installStartTime + (item.installEndTime ? ' - ' +
                                item.installEndTime.split(' ')[1] : '');
                        }
                        if (item.networkAppointmentStart) {
                            item.networkAppointmentTime =
                                item.networkAppointmentStart + (item.networkAppointmentEnd ? ' - ' +
                                item.networkAppointmentEnd.split(' ')[1] : '');
                        }
                        if (item.expectArriveStartTime) {
                            item.expectArriveTime =
                                item.expectArriveStartTime + (item.expectArriveEndTime ? ' - ' +
                                item.expectArriveEndTime.split(' ')[1] : '');
                        }
                        if (item.expectInstallStartTime) {
                            item.expectInstallTime =
                                item.expectInstallStartTime + (item.expectInstallEndTime ? ' - ' +
                                item.expectInstallEndTime.split(' ')[1] : '');
                        }
                        item.networkReceiptStatusName =
                                item.networkReceiptStatus === 'Y' ? '是' : '否';
                        item.finalReceiptStatusName =
                                item.finalReceiptStatus === 'Y' ? '是' : '否';
                        item.finalSignFullName =
                                item.finalSignFull === 'Y' ? '是' : '否';
                        item.thirdFlagName =
                                +item.thirdFlag === 1 ? '是' : '否';
                        item.isJzpName =
                                item.isJzp === 'Y' ? '是' : '否';
                        item.addedserviceType2CName =
                                +item.addedserviceType2C === 1 ? '是' : '否';
                        if (item.cnInstallFlag) {
                            item.cnInstallFlagName =
                                +item.cnInstallFlag === 0 ? '否' : '是';
                        } else {
                            item.cnInstallFlagName = '否';
                        }
                        item.showPhotos = true;
                        item.hiddenEvent = [];
                        // 预约
                        if (!((item.orderStatus >= 100 && item.orderStatus < 150 && item.interceptFlag !== 1) ||
                            (['DP', 'RI'].includes(item.orderType) && [30, 145].includes(item.orderStatus) && item.interceptFlag !== 1))) {
                            item.hiddenEvent.push('appointment');
                        }
                        // 费用申请按钮
                        if (item.businessMode === 'B2B' ||
                            item.interceptFlag === 1 ||
                            !((['PO', 'YS'].includes(item.orderType) && item.orderStatus >= 140 && item.orderStatus <= 880) ||
                            (item.orderType === 'DP' && item.orderStatus >= 140 && item.orderStatus <= 210))) {
                            item.hiddenEvent.push('fundRequest');
                        }
                        // 网点签收 type=1
                        if (
                            !(
                                (['PO', 'YS'].includes(item.orderType) &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT' &&
                                    item.orderStatus === 40) ||
                                    (item.orderStatus === 30 && ['PO', 'YS', 'DO'].includes(item.orderType) && item.businessMode === 'B2B')
                            )
                        ) {
                            item.hiddenEvent.push('branchSign');
                        }
                        // 网点拒收 type=10
                        if (
                            !((
                                (['PO', 'YS'].includes(item.orderType) &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT' &&
                                    item.orderStatus === 40) ||
                                    (item.orderStatus === 30 && ['PO', 'YS', 'DO'].includes(item.orderType) && item.businessMode === 'B2B')
                            ) && item.c2mType === 'HWM')
                        ) {
                            item.hiddenEvent.push('branchReject');
                        }
                        // 用户签收(2B) type=2
                        if (
                            !(
                                (['PO', 'YS', 'DO'].includes(item.orderType) &&
                                    [140, 145].includes(item.orderStatus) &&
                                    item.businessMode === 'B2B' &&
                                    item.interceptFlag !== 1) ||
                                    (item.orderType === 'PO' && item.businessMode === 'B2B' &&
                                    +item.orderStatus === 250)
                            )
                        ) {
                            item.hiddenEvent.push('finalSign');
                        }
                        // 网点入库 type=3
                        if (
                            !(
                                (item.orderType === 'HT' &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT' &&
                                    item.orderStatus === 30) ||
                                    ([140, 145].includes(item.orderStatus) &&
                                    item.orderType === 'RI' &&
                                    item.businessMode === 'B2B') ||
                                    (item.orderType === 'HT' &&
                                    item.businessMode === 'B2B' &&
                                    item.deliveryType === 'NET' &&
                                    item.orderStatus === 30)
                            )
                        ) {
                            item.hiddenEvent.push('netInbound');
                        }
                        // 网点出库 type=4
                        if (
                            !(
                                (item.orderType === 'HT' &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT' &&
                                    [230, 235].includes(item.orderStatus)) ||
                                    (item.orderStatus === 230 &&
                                    item.orderType === 'RI' &&
                                    item.businessMode === 'B2B') ||
                                    (item.orderType === 'HT' &&
                                    item.businessMode === 'B2B' &&
                                    item.deliveryType === 'NET' &&
                                    [230, 235].includes(item.orderStatus))
                            )
                        ) {
                            item.hiddenEvent.push('netOutbound');
                        }
                        // 用户签收(2C) type=5
                        if (
                            !(
                                ['PO', 'YS'].includes(item.orderType) &&
                                    [140, 145].includes(item.orderStatus) &&
                                    item.deliveryType === 'DOT' &&
                                    item.businessMode === 'B2C' &&
                                    item.interceptFlag !== 1
                            )
                        ) {
                            item.hiddenEvent.push('clientSign');
                        }
                        // 用户拒签 type=6
                        if (
                            !(
                                ((['PO', 'YS'].includes(item.orderType) &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT') ||
                                     (item.sourceSystem === 'CAINIAO' && item.orderType === 'PO' &&
                                    item.businessMode === 'B2B' && item.deliveryType === 'NET')) &&
                                    [140, 145].includes(item.orderStatus)
                            )
                        ) {
                            item.hiddenEvent.push('clientReject');
                        }
                        // 用户拒签审核 type=7
                        if (
                            !(
                                ((['PO', 'YS'].includes(item.orderType) &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT') ||
                                     (item.sourceSystem === 'CAINIAO' && item.orderType === 'PO' &&
                                    item.businessMode === 'B2B' && item.deliveryType === 'NET')) &&
                                    item.orderStatus === 170
                            )
                        ) {
                            item.hiddenEvent.push('rejectConfirm');
                        }
                        // 上门取件 type=8
                        if (
                            !(
                                item.orderType === 'DP' &&
                                    [140, 145].includes(item.orderStatus)
                            )
                        ) {
                            item.hiddenEvent.push('pickup');
                        }
                        // 取件失败审核 type=9
                        if (!(
                            item.orderType === 'DP' &&
                                    item.orderStatus === 195
                        )) {
                            item.hiddenEvent.push('pickupConfirm');
                        }
                        // 签收审核 type=11
                        if (!(
                            item.orderType === 'PO' && item.businessMode === 'B2B' &&
                                    +item.orderStatus === 300
                        )) {
                            item.hiddenEvent.push('signConfirm');
                        }
                        // 生成回退单
                        if (
                            !(
                                ['PO', 'YS'].includes(item.orderType) &&
                                    item.businessMode === 'B2C' &&
                                    item.deliveryType === 'DOT' &&
                                    item.orderStatus === 180
                            )
                        ) {
                            item.hiddenEvent.push('createReturn');
                        }
                        // 异常反馈
                        if (
                            !(
                                (item.orderType === 'DP' && item.orderStatus >= 30 && item.orderStatus < 210) ||
                                    (item.orderType !== 'DP' && item.orderStatus >= 100 &&
                                    item.orderStatus < 200 && item.orderStatus !== 150 && item.orderStatus !== 180)
                            )
                        ) {
                            item.hiddenEvent.push('feedback');
                        }
                        // 签收改拒收
                        if (!(['PO', 'YS'].includes(item.orderType) && [150, 880].includes(item.orderStatus) && item.businessMode === 'B2C')) {
                            item.hiddenEvent.push('toReject');
                        }
                        // 网点拒收时，隐藏所有行操作按钮
                        if (+item.orderStatus === 105) {
                            item.hiddenEvent = ['branchReject', 'toReject', 'feedback', 'print', 'fundRequest',
                                'createReturn', 'signConfirm', 'pickupConfirm', 'rejectConfirm', 'netOutbound',
                                'netInbound', 'pickup', 'clientReject', 'clientSign', 'finalSign', 'appointment', 'branchSign'];
                        }
                    });
                    this.totalData = list;
                }
            }).catch(() => {});
            this.isFirstSearch = false;
            this.loading = false;
            api.getListCount(this.searchParams).then(res => {
                if (res && res.code === '0') {
                    this.pageTotal = res.data;
                }
            }).catch(() => {});
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.isFirstSearch ? this.$refs.tablePage.$refs.searchList.onSearchChange() : this.getList();
        },
        sizeChange(data) {
            this.searchParams.pageSize = data;
            this.isFirstSearch ? this.$refs.tablePage.$refs.searchList.onSearchChange() : this.getList();
        },
        selectChange(data) {
            this.selected = data;
        },
        // 通用删除弹窗功能,使用v-if为减少页面组件同时加载数量，减轻用户设备压力
        closeDialog(dialogName, isRefresh) {
            this[dialogName] = false;
            isRefresh && this.getList();
        },
        // 日志弹窗
        async btnClick(value, index, rowData) {
            this.loading = true;
            const logParams = {
                orderNo: rowData.orderNo,
                orderBy: 'id',
                orderByType: 'desc',
                pageSize: 100
            };
            await api.netOrderLogs(logParams).then(res => {
                if (res && res.code === '0') {
                    this.logData = res.data.list;
                    this.logVisible = true;
                }
            }).catch(() => {});
            this.loading = false;
        },
        // 网点派单按钮/改派按钮
        sendOrder(changeFlag, allCenter) {
            if (!this.selected.length) { return this.$message.warning('请先选择订单'); }
            let statusFlag = true;
            let netFlag = true;
            let netList = [];
            if (!changeFlag) {
                this.selected.forEach((item) => {
                    if (item.orderStatus !== 20) {
                        statusFlag = false;
                    }
                    netList.push(item.netTaskAddress.networkCenterCode);
                });
            } else {
                this.selected.forEach((item) => {
                    if (item.orderStatus !== 30) {
                        statusFlag = false;
                    }
                    netList.push(item.netTaskAddress.networkCenterCode);
                });
            }
            if (!statusFlag) return this.$message.warning('存在不可改派的订单');
            netList = _.uniq(netList); // 去重
            if (netList.length > 1) {
                netFlag = false;
                return this.$message.warning('批量操作请选择相同分中心的订单');
            }
            if (!statusFlag || !netFlag) return;
            this.sendOrderDialog = true;
            this.$nextTick(() => {
                this.$refs.sendOrder.show(changeFlag, this.selected, allCenter);
            });
        },
        // 派工按钮
        async engineerDispatch() {
            if (!this.selected.length) return this.$message.warning('请先选择订单！');
            if (this.selected.length > 1) return this.$message.warning('只能选择一条单据进行派工！');
            let statusFlag = true;
            let hasCainiao = false;
            let notCainiao = false;
            const cainiaoList = [];
            await this.selected.forEach(item => {
                // 判断订单状态
                if (item.businessMode === 'B2C' && (item.orderStatus < 120 || item.orderStatus > 145)) {
                    statusFlag = false;
                } else if (item.businessMode === 'B2B' && (item.orderStatus < 100 || item.orderStatus > 145)) {
                    statusFlag = false;
                } else if (item.sourceSystem === 'CAINIAO' && item.businessMode === 'B2B' && (item.orderStatus < 120 || item.orderStatus > 145)) {
                    statusFlag = false;
                }
                // 判断是否天猫优品订单
                if (item.sourceSystem === 'CAINIAO' && item.businessMode === 'B2B' && item.orderType === 'PO') {
                    cainiaoList.push(item.customerOrderNo);
                    hasCainiao = true;
                } else {
                    notCainiao = true;
                }
            });
            if (hasCainiao && notCainiao) {
                return this.$message.warning('菜鸟B2B订单与其他类型订单请分开派工');
            }
            if (_.uniq(cainiaoList).length > 1) {
                return this.$message.warning(
                    {
                        dangerouslyUseHTMLString: true,
                        message: `菜鸟B2B订单请按客户订单号操作派工`,
                        type: 'warning'
                    });
            }
            if (!statusFlag) return this.$message.warning('存在不可派工的订单');
            this.engineerDispatchDialog = true;
            this.$nextTick(() => {
                if (this.selected[0].sourceSystem === 'CAINIAO' && this.selected[0].businessMode === 'B2B') {
                    this.$refs.engineerDispatch.show(this.selected[0], true);
                } else {
                    this.$refs.engineerDispatch.show(this.selected[0], false);
                }
            });
        },
        // 下发
        async handleSendout() {
            if (!this.selected.length) return this.$message.warning('请先选择订单');
            let statusFlag = true;
            const orderList = [];
            this.selected.forEach(item => {
                orderList.push(item.orderNo);
                if (item.orderStatus !== 10) statusFlag = false;
            });
            if (!statusFlag) return this.$message.warning('仅[订单接入]状态的订单可下发');
            this.loading = true;
            await api.handleSendout(orderList).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('处理成功');
                    this.getLists();
                }
            }).catch(() => {});
            this.loading = false;
        },
        // 处理异常
        async handleError() {
            if (!this.selected.length) return this.$message.warning('请先选择订单');
            const orderList = [];
            let poFlag = true;
            let statusFlag = true;
            await this.selected.forEach(item => {
                if (item.orderType !== 'PO' && item.orderType !== 'DP') poFlag = false;
                if (item.orderStatus > 30) statusFlag = false;
                orderList.push(item.orderNo);
            });
            if (!poFlag) return this.$message.warning('只有 [销售出库单] 及 [上门取件单] 允许操作处理异常！');
            if (!statusFlag) return this.$message.warning('当前订单状态无法操作处理异常！');
            this.loading = true;
            await api.handleError(orderList).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('处理成功');
                    this.getLists();
                }
            }).catch(() => {});
            this.loading = false;
        },
        // 批量打印派工单
        handlePrint() {
            if (!this.selected.length) return this.$message.warning('请先选择订单！');
            if (this.selected.length > 40) return this.$message.warning('最多只能打印40单！');
            let orderList = null;
            orderList = this.selected.map(item => {
                return item.orderNo;
            });
            orderList = orderList.join(',');
            const api = `${process.env.VUE_APP_API_URL}/api-otp/netTask/printfBatch?orderNos=${orderList}&type=6`;
            window.open(api);
        },
        // 预约按钮
        appointmentBtn(rowData) {
            this.rowData = rowData;
            if (rowData.sourceSystem === 'CAINIAO' && rowData.businessMode === 'B2B' && rowData.orderType === 'PO') {
                this.appointmentNewDialog = true;
                this.$nextTick(() => {
                    this.$refs.appointmentNew.show(rowData);
                });
                return;
            }
            this.appointmentDialog = true;
            this.$nextTick(() => {
                this.$refs.appointment.show(rowData);
            });
        },
        // 远程费用申请按钮
        fundRequestBtn(rowData) {
            this.fundRequestDialog = true;
            this.$nextTick(() => {
                this.$refs.fundRequestDialog.show(rowData);
            });
        },
        // 网点签收
        branchSignBtn(data) {
            this.rowData = data;
            (data.businessMode === 'B2B' && data.sourceSystem !== 'CAINIAO') ? this.branchSignDialog = true : this.branchSignNewDialog = true;
            this.type = '1';
        },
        // 用户签收 2B
        finalSignBtn(data) {
            this.rowData = data;
            if (data.sourceSystem === 'CAINIAO' && data.orderType === 'PO' && data.deliveryType === 'NET') {
                this.branchSignNewDialog = true;
                this.type = '5';
                return;
            }
            this.branchSignDialog = true;
            this.type = '2';
        },
        // 网点入库
        netInboundBtn(data) {
            this.rowData = data;
            if (data.sourceSystem === 'CAINIAO' && data.businessMode === 'B2B' && data.deliveryType === 'NET') {
                this.branchSignNewDialog = true;
                this.type = '3';
                return;
            }
            data.businessMode === 'B2B' ? this.branchSignDialog = true : this.branchSignNewDialog = true;
            this.type = '3';
        },
        // 网点出库
        netOutboundBtn(data) {
            this.rowData = data;
            if (data.sourceSystem === 'CAINIAO' && data.businessMode === 'B2B' && data.deliveryType === 'NET') {
                this.branchSignNewDialog = true;
                this.type = '4';
                return;
            }
            data.businessMode === 'B2B' ? this.branchSignDialog = true : this.branchSignNewDialog = true;
            this.type = '4';
        },
        // 用户签收 2C
        clientSignBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '5';
        },
        // 用户拒签
        clientRejectBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '6';
        },
        // 拒签审核
        rejectConfirmBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '7';
        },
        // 上门取件
        pickupBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '8';
        },
        // 取件失败审核
        pickupConfirmBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '9';
        },
        // 签收审核
        signConfirmBtn(data) {
            this.branchSignDialog = true;
            this.rowData = data;
            this.type = '11';
        },
        // 签收改拒收按钮
        toRejectBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '6';
        },
        // 网点拒收按钮
        branchRejectBtn(data) {
            this.branchSignNewDialog = true;
            this.rowData = data;
            this.type = '10';
        },
        // 打印弹窗按钮
        printBtn(data) {
            this.printerDialog = true;
            this.$nextTick(() => {
                this.$refs.printer.show(data);
            });
        },
        // 异常反馈按钮
        feedbackBtn(data) {
            this.errorFeedbackDialog = true;
            this.$nextTick(() => {
                this.$refs.errorFeedback.show(data);
            });
        },
        // 生成回退单按钮
        async createReturnBtn(data) {
            this.loading = true;
            await api
                .createReturnOrder({ orderNo: data.orderNo })
                .then((res) => {
                    if (res && res.code === '0') {
                        this.$message.success('回退单生成成功');
                        this.getLists();
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        // 行内附件按钮
        photosBtn(data) {
            if (!(+data.orderStatus === 999)) {
                this.rowData = data;
                this.netAttachmentShow = true;
            } else {
                this.$message.warning('取消订单不允许附件上传！');
            }
        },
        beforeUpload({ file }) {
            const extArr = ['jpg', 'jpeg', 'png', 'tif', 'bmp'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / TIF / BMP',
                    duration: 5000,
                    showClose: true
                });
                return false;
            }
            return file;
        },
        async branchSignUploadResponse(response) {
            // 弹框的上传
            const params = {
                orders: [this.rowData.orderNo],
                type: this.type
            };
            params.images = response.map((item) => item.data.downUrl);
            await api
                .netUpload(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('上传成功');
                        if (this.$refs.branchSign) {
                            this.$refs.branchSign.$refs.signUpload.$refs.ossElUpload.clearFiles();
                            this.$refs.branchSign.updateImgList();
                        }
                        if (this.$refs.branchSignNew) {
                            this.$refs.branchSignNew.$refs.signUpload.$refs.ossElUpload.clearFiles();
                            this.$refs.branchSignNew.updateImgList();
                        }
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        getFileExt(fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        viewTypeChange(type) {
            this.type = type;
        },
        rowDBclick(row) {
            this.$router.push({
                query: { orderNo: row.orderNo, orderType: row.orderType, businessMode: row.businessMode },
                path: '/net-task-details'
            });
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        ...mapState({ user: (state) => state.user })
    }
};
</script>
<style lang="less">
@import './netTask.less';
</style>
